
const primaryColor = '#343896';
const primary4 = '#D5D5E9';
const primary3 = '#E4E4F1';
const colorError = 'rgb(245, 34, 45)';
const colorSuccess = ' #28a745';
const colorWarning = '#faad14';
const gray11 = '#1f1f1f';

export const defaultTheme = {
    token: {
        colorPrimary: primaryColor,
        colorError: colorError,
        colorSuccess: colorSuccess,
        colorWarning: colorWarning,
        colorInfo: primaryColor,
        borderRadius: 3,
        colorLink: primaryColor,
        fontFamily: "'Poppins', sans-serif", 
        yellow: colorWarning,
        fontSizeHeading1: 28,
        colorSplit: '#E0E0E0',
    }, 

    components: {
        Button: {
            primaryShadow: 'none',
            defaultShadow: 'none',
            boxShadow: 'none', 
            boxShadowSecondary: 'none', 
            boxShadowHover: 'none',
            boxShadowActive: 'none',
            ghostBg: 'transparent',
        },
        Menu: {
            darkItemColor: 'white',
            darkSubMenuItemBg: 'white',
            subMenuItemBg: 'white',
            itemSelectedColor: primaryColor,
            itemHoverColor: primaryColor,
            itemSelectedBg: primary3,
        },
        Notification: {
            colorSuccessBg: '#fff', 
            colorErrorBg: '#fff', 
            colorWarningBg: '#fff', 
            colorInfoBg: '#fff', 
        },
        Select: {
            optionSelectedBg: primary3,
        },
        TreeSelect: {
            treeNodePadding: 0,
            treeNodeSwitcherSize: 0,
            indentSize: 0,
        },
        Layout: {
            siderBg: gray11,
        }, 
        List: {
            colorText: '#fff',
        }
    }
}